import classNames from 'classnames'
import React from 'react'
import { Button } from 'react-bootstrap'

import { useHubspotChat } from '../../hooks/useHubspotChat'

interface Props {
  children: React.ReactNode
  className?: string
  usePlainButtonClasses?: boolean
}

const OpenChatButton: React.FC<Props> = ({
  children,
  className,
  usePlainButtonClasses = true,
}) => {
  const hubspotChat = useHubspotChat()

  return (
    <Button
      onClick={hubspotChat.openChat}
      className={classNames(className, {
        'fs-inherit text-primary PlainButton': usePlainButtonClasses,
      })}
      css={
        usePlainButtonClasses
          ? {
              // Make it wrap just like an anchor would
              display: 'contents',
            }
          : undefined
      }
    >
      <span
        css={
          usePlainButtonClasses
            ? {
                ':hover': {
                  textDecoration: 'underline',
                },
              }
            : undefined
        }
      >
        {children}
      </span>
    </Button>
  )
}

export default OpenChatButton
